// Vær-service via Open-Meteo (gratis, ingen API-nøkkel)

const CONDITION_MAP = {
  0: 'Opplett',
  1: 'Opplett',
  2: 'Overskyet',
  3: 'Overskyet',
  45: 'Overskyet',
  48: 'Overskyet',
  51: 'Regn',
  53: 'Regn',
  55: 'Regn',
  56: 'Regn',
  57: 'Regn',
  61: 'Regn',
  63: 'Regn',
  65: 'Regn',
  66: 'Regn',
  67: 'Regn',
  71: 'Regn',
  73: 'Regn',
  75: 'Regn',
  77: 'Regn',
  80: 'Regn',
  81: 'Regn',
  82: 'Regn',
  85: 'Regn',
  86: 'Regn',
  95: 'Regn',
  96: 'Regn',
  99: 'Regn',
};

const WIND_DIR_LABELS = ['N', 'NØ', 'Ø', 'SØ', 'S', 'SV', 'V', 'NV'];

function degreesToDirection(deg) {
  const index = Math.round(deg / 45) % 8;
  return WIND_DIR_LABELS[index];
}

const weatherService = {
  async fetchWeather(lat, lng, timestamp) {
    try {
      const date = new Date(timestamp);

      // Bygg dato + time fra LOKAL tid (ikke UTC) for å matche timezone=auto
      const pad = (n) => String(n).padStart(2, '0');
      const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
      const hourStr = `${dateStr}T${pad(date.getHours())}:00`;

      // Velg riktig API basert på hvor gammel fangsten er.
      // Forecast-API dekker prognose + ca. 3 måneder tilbake. Eldre datoer
      // finnes ikke der, så da bruker vi arkiv-API (ERA5) som går tilbake til
      // 1940. Arkivet er forsinket ~5 dager, så for nylige datoer holder vi
      // oss til forecast-API (som også har de aller siste dagene/prognosen).
      const ageInDays = (Date.now() - date.getTime()) / (1000 * 60 * 60 * 24);
      const useArchive = ageInDays > 80;

      // wind_speed_unit=ms -> vind i m/s (matcher appens UI).
      // temperature_2m er Celsius som standard.
      const baseUrl = useArchive
        ? 'https://archive-api.open-meteo.com/v1/archive'
        : 'https://api.open-meteo.com/v1/forecast';
      const url = `${baseUrl}?latitude=${lat}&longitude=${lng}&hourly=temperature_2m,wind_speed_10m,wind_direction_10m,weather_code&wind_speed_unit=ms&timezone=auto&start_date=${dateStr}&end_date=${dateStr}`;

      const res = await fetch(url);
      if (!res.ok) return null;

      const data = await res.json();
      const h = data.hourly;
      if (!h || !h.time || !h.time.length) return null;

      // Finn eksakt time i tidslista; fall tilbake til nærmeste time
      let idx = h.time.indexOf(hourStr);
      if (idx === -1) {
        const targetHour = date.getHours();
        idx = Math.min(Math.max(targetHour, 0), h.time.length - 1);
      }

      const temp = h.temperature_2m?.[idx];
      const wind = h.wind_speed_10m?.[idx];
      const windDeg = h.wind_direction_10m?.[idx];
      const code = h.weather_code?.[idx];

      return {
        temp: temp != null ? Math.round(temp) : null,
        wind: wind != null ? Math.round(wind) : null,
        windDir: windDeg != null ? degreesToDirection(windDeg) : null,
        condition: code != null ? (CONDITION_MAP[code] || 'Overskyet') : null,
      };
    } catch (err) {
      console.error('Vær-henting feilet:', err);
      return null;
    }
  },
};

export default weatherService;
